<template>
<div class="page_smart_park pB100">
	<!-- <div class="buyicon" @click="toBuyCard"> 
	</div> -->
	<div class="container bg" v-if="info">
		<div class="nr" v-html="info.content"></div>
	</div>
	<div class="bottom">
		<!-- <div class="action" @click="toShopList">选择参观馆</div> -->
		<div class="action" @click="toBuyTicket">通票</div>
	</div>
</div>
</template>

<script>
import router from "../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../.././vuex/mutation_types";
import PageSearch from "../../../component/search/Index.vue";
import Vue from "vue";
import Bridge from "../../../.././vuex/bridge.js";
Vue.prototype.$bridge = Bridge;
var userAgent = navigator.userAgent;

export default {
    name: "smart-park",
    data() {
        return {
			richImageUrl: this.$publicData.richTextImage,
            publicPath: process.env.BASE_URL,
            id: 1, // id是后台配的,先直接写死1
			info: null // 园区信息
        };
    },
    components: {
        PageSearch,
    },
    created: function () {
        //根据userAgent判断是否在iOSAndroid客户端中，隐藏原生导航栏
        var that = this
        if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
            var params = {
                data: {
                    // hiddenNavi: true,
                    naviTitle: '智慧园区',
                    'rightStyle': 'share'
                }
            };
            this.$bridge.callhandler("sdjy://navigation/style", params, (data) => {});
            //获取用户信息
            var memberParams = {
                data: {
                    notCallLogin: 1,
                },
            };
            this.$bridge.callhandler(
                "sdjy://member/memberInfo",
                memberParams,
                (data) => {
                    if (data.code == 200) {
                        this.token = data.result.token;
                    } else {
                        this.token = "";
                    }
                    // 调用某方法
                }
            );
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler(
                "sdjy://common/refreshPage",
                (data, responseCallback) => {
                    // alert(JSON.stringify(data));
                    responseCallback(data);
                }
            );
            //注册方法，右侧点击分享
            this.$bridge.registerhandler('sdjy://common/rightButtonAction', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                console.log('sdjy://common/rightButtonAction')
                const url = location.href.split('#')[0];
                var params = {
                    data: {
                        title: '时代记忆 智慧园区',
                        detail: '追寻时代记忆，传承时代精神',
                        url: url,
                        platFormType:'',
                        image: that.$publicData.shareImgPath + 'yuanqu.jpeg'
                    },
                };
                this.$bridge.callhandler('sdjy://public/share', params, (data) => {

                })

            })
        } else {
            this.token = this.$store.getters.token;
        }
        // 园区信息
		this.getData()
		// 调起 获取微信分享参数函数 -- 弃用,改成统一配置的
        this.getShareData()
    },
    methods: {
		// 获取园区信息
		getData(){
			var that = this
			var params = {
				id: that.id
			}
			that.$api.smartpark.index(params).then(res=>{
				if(res.code == 200){
					// 处理富文本
					let info = res.result;
					info.content = info.content.replace(/(<img [^>]*src=['"])([^'"]+)([^>]*)/g,function(match,$1,$2,$3){
						if(/^http/.test($2)){
							return $1 + $2 + $3;
						}else{
							return $1 + that.richImageUrl +$2 + $3;
						}
					})
					that.info = info;
				}
			})
		},
		// 参观馆
		toShopList(){
			var that = this
            if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
                var params = {
					'data': {
						'url': that.$publicData.clientUrl + '/smart/park/shoplist?id='+that.id
						}
					}
				that.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

				})
            } else {
                that.$router.push({
                    path: '/smart/park/shoplist',
                    query: {
                        id: that.id
                    }
                })
            }
			
		},
		// 去买通票
		toBuyTicket(){
			var that = this
            if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
                var params = {
					'data': {
						'url': that.$publicData.clientUrl + '/smart/park/appointticket?is_through_ticket=1'
						}
					}
				that.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

				})
            } else {
                that.$router.push({
                    path: '/smart/park/appointticket',
                    query: {
                        is_through_ticket: 1 // 是否通票 1是 0否
                    }
                })
            }
		},
		// 去买次卡
		toBuyCard(){
            var that = this
            if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
                var params = {
					'data': {
						'url': that.$publicData.clientUrl + '/smartpark/card/list'
						}
					}
				that.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

				})
            } else {
                that.$router.push({
                    path: '/smartpark/card/list'
                })
            }
		},
        // 获取分享参数 -- 用于配微信分享
        getShareData() {
            const url = location.href.split('#')[0];
            console.log('url', url)
            this.$api.index.commonShare({
                url: url
            }).then(res => {
                if (res.code == 200) {
                    this.shareConfig = res.result
                    // console.log('this.shareConfig', this.shareConfig)
                    // console.log('this.$route', this.$route)
                    this.shareFun()
                }
            })
        },
        // 分享
        shareFun() {
            var that = this
            wx.config({
                debug: that.shareConfig.debug,
                beta: that.shareConfig.beta,
                jsApiList: that.shareConfig.jsApiList,
                appId: that.shareConfig.appId,
                nonceStr: that.shareConfig.nonceStr, // 随机串
                timestamp: parseInt(that.shareConfig.timestamp), // 时间戳
                signature: that.shareConfig.signature // 签名
            });
            // 分享
            wx.ready(function () {
                const url = location.href.split('#')[0];
                var shareData = {
                    title: '时代记忆 智慧园区', // 分享标题
                    desc: '追寻时代记忆，传承时代精神', // 分享描述
                    link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: that.$publicData.shareImgPath + 'yuanqu.jpeg', // 分享图标
                    success: function () {
                        // 用户确认分享后执行的回调函数
                        // alert('成功')
                    },
                    cancel: function (e) {
                        // alert(e)
                        // 用户取消分享后执行的回调函数
                    }
                }
                wx.updateAppMessageShareData(shareData);
                wx.updateTimelineShareData(shareData);
            });
        }
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.page_smart_park .bottom .action{
    width: 90%;
}
</style>
